import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Form, Input, Row, Col, Typography, Select } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import TextArea from 'antd/es/input/TextArea';
import { mobileRegexNew, mobileRegexhk } from 'utils/regex';
import { Spinner } from 'components';
import { MobileNumberHasAreaPrefix } from 'components';
import { useProfileInfoContext } from 'contexts/profileInfo';
import { usePolicyDropDown, useLifeUserProfile } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
// import styled from 'styled-components';

export const EnquiryInfoCard = () => {
  const { t, i18n } = useTranslation();
  const [RequiresPhone, setRequiresPhone] = useState(false);
  const [RequiresMail, setRequiresMail] = useState(false);
  const form = useFormInstance();
  const phone = Form.useWatch('phone', form);
  const mail = Form.useWatch('mail', form);
  const { keycloak } = useKeycloakReady();
  const [showCard, setShowCard] = useState<boolean>(false);
  const { state: data, isLoading } = useProfileInfoContext();
  const [startLoading, setStartLoading] = useState<boolean>(false);
  const { shouldFetch: profileshouldFetch, data: profileInfoData } = useLifeUserProfile(
    'useLifeUserProfile',
    keycloak.token || '',
  );
  useEffect(() => {
    if (profileInfoData) {
      profileshouldFetch(false);
      setStartLoading(false);
      form.setFieldsValue({
        name: `${profileInfoData.firstName} ${profileInfoData.lastName}`,
        mail: profileInfoData.email,
        // phone: profileInfoData.mobile,
      });
    }
  }, [data, form, profileshouldFetch, profileInfoData]);
  useEffect(() => {
    setStartLoading(true);
    profileshouldFetch(true);
  }, [keycloak.token, profileshouldFetch]);
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      setShowCard(true);
    } else {
      setShowCard(false);
    }
  };
  const handleChange = useCallback(
    (value: string) => {
      form.setFieldsValue({
        countryCode: value,
      });
      // if (value) {
      //   setShowCard(true);
      // } else {
      //   setShowCard(false);
      // }
    },
    [form],
  );
  useEffect(() => {
    handleChange('+852');
    if (form.getFieldValue('phone')) {
      setShowCard(true);
    } else {
      setShowCard(false);
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [handleChange, setShowCard, form]);
  const { shouldFetch: shouldFecthDrop, data: dropData } = usePolicyDropDown('usePolicyDropDown', keycloak.token || '');
  const policyTypesObject: { label: string; label2: string; value: string }[] = [];
  dropData?.map((item) => {
    policyTypesObject.push({
      label: i18n.language == 'en' ? item.productName : item.productNameTC,
      label2: `${t('life.enquiry.policyNo')}${item.policyNumber}`,
      value: item.policyNumber,
    });
  });
  const enquiryTypesObject = [
    {
      label: t('life.enquiry.lifetype.CONTACT_DETAIL_CHANGE'),
      value: t('life.enquiry.lifetype.CONTACT_DETAIL_CHANGE'),
    },
    { label: t('life.enquiry.lifetype.CLAIM'), value: t('life.enquiry.lifetype.CLAIM') },
    {
      label: t('life.enquiry.lifetype.POLICY_INFORMATION'),
      value: t('life.enquiry.lifetype.POLICY_INFORMATION'),
    },
    { label: t('life.enquiry.lifetype.POLICY_CHANGE'), value: t('life.enquiry.lifetype.POLICY_CHANGE') },
    { label: t('life.enquiry.lifetype.PREMIUM'), value: t('life.enquiry.lifetype.PREMIUM') },
    { label: t('life.enquiry.lifetype.E_SERVICES'), value: t('life.enquiry.lifetype.E_SERVICES') },
    {
      label: t('life.enquiry.lifetype.ENQUIRY_AND_FEEDBACK'),
      value: t('life.enquiry.lifetype.ENQUIRY_AND_FEEDBACK'),
    },
    { label: t('life.enquiry.lifetype.OTHER'), value: t('life.enquiry.lifetype.OTHER') },
  ];
  const timeTypesObject = [
    { label: `${t('life.enquiry.anytime')}`, value: `${t('life.enquiry.anytime')}` },
    { label: `${t('life.enquiry.morning')}`, value: `${t('life.enquiry.morning')}` },
    { label: `${t('life.enquiry.afternoon')}`, value: `${t('life.enquiry.afternoon')}` },
  ];

  useEffect(() => {
    console.log('mail', !mail);
    setRequiresPhone(!mail);
    setRequiresMail(!phone);
    // if (form.isFieldTouched('phone') || form.isFieldTouched('mail')) {
    //   form.validateFields(['phone', 'mail']);
    // }
    shouldFecthDrop(true);
  }, [form, mail, phone, shouldFecthDrop]);

  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
      <Col xs={24} md={24}>
        <Typography.Text className="headertittle">{t('life.enquiry.description')}</Typography.Text>
      </Col>
      <Col xs={24} md={24} style={{ marginBottom: '10px' }}>
        <Typography.Text className="headertext">{t('life.enquiry.mandatoryMsg')}</Typography.Text>
      </Col>
      {(isLoading || startLoading) && <Spinner />}
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          rules={[{ required: true }]}
          label={
            <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.enquiry.nameLabel')}
            </span>
          }
          name="name"
        >
          <TextArea
            disabled
            placeholder={t('life.enquiry.nameplacehoder')}
            style={{
              border: 'none',
              borderBottom: '1px solid #CCCCCC',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
              resize: 'none',
            }}
            autoSize
            className="no-scrollbar"
          />
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          rules={[
            { required: RequiresMail, message: t('life.enquiry.error.enquiryMessageError') },
            { type: 'email', message: t('life.enquiry.error.emailerror') },
          ]}
          required
          label={
            <div>
              {RequiresMail && (
                <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.enquiry.emailLabel')}*
                </span>
              )}
              {!RequiresMail && (
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.enquiry.emailLabel')}
                </span>
              )}
            </div>
          }
          name="mail"
        >
          <Input
            size="middle"
            placeholder={t('life.enquiry.emailPlaceholder')}
            style={{
              border: 'none',
              borderBottom: '1px solid #CCCCCC',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
            }}
          />
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24}>
        <Form.Item
          label={
            <div>
              {RequiresPhone && (
                <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.enquiry.phoneLabel')}*
                </span>
              )}
              {!RequiresPhone && (
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.enquiry.phoneLabel')}
                </span>
              )}
            </div>
          }
          className="mobile"
          style={{ marginBottom: 12 }}
        >
          <div className="countryCodestyle">
            <Form.Item name="countryCode">
              {/* <MobileNumberPrefix defaultValue="+852" handleChange={handleChange} /> */}
              <MobileNumberHasAreaPrefix defaultValue="+852" handleChange={handleChange} />
            </Form.Item>
          </div>
          <div className="phonestyle">
            <Form.Item
              rules={[
                { required: RequiresPhone, message: t('enquiry.error.contactError') },
                () => ({
                  validator(_, value) {
                    if (
                      !value ||
                      (form.getFieldValue('countryCode').trim() == '+852'
                        ? mobileRegexhk.test(value)
                        : mobileRegexNew.test(value))
                    ) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(new Error(t('life.MakeClaim.phoneLabelrules')));
                    }
                  },
                }),
              ]}
              required
              name="phone"
            >
              <Input
                size="middle"
                onChange={onChange}
                placeholder={t('life.enquiry.phoneLabel')}
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                }}
              />
            </Form.Item>
          </div>
        </Form.Item>
      </Col>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          label={
            <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.enquiry.policyLabel')}
            </span>
          }
          name="PolicyNo"
        >
          {/* <Select
            mode="multiple"
            allowClear
            style={{
              width: '100%',
              fontSize: '20px',
              fontFamily: 'Roboto400',
            }}
            placeholder={t('life.enquiry.typePlaceholder')}
            onChange={handleChange}
            options={policyTypesObject}
          /> */}
          <Select
            mode="multiple"
            placeholder={t('life.enquiry.policyPlaceholder')}
            popupClassName="slectop"
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
            }}
          >
            {policyTypesObject &&
              policyTypesObject.map((item) => (
                <Select.Option key={item.value} value={item.value} label2={item.label2} title={item.label2}>
                  <div style={{ display: 'grid' }}>
                    <span>{item.label}</span>
                    <span>{item.label2}</span>
                  </div>
                </Select.Option>
              ))}
          </Select>
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          rules={[{ required: true, message: t('life.enquiry.lifeTypePlaceholder') }]}
          required
          label={
            <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.enquiry.typeLabel')}
            </span>
          }
          name="enquiryType"
        >
          <Select
            placeholder={t('life.enquiry.lifeTypePlaceholder')}
            popupClassName="slectop"
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
            }}
          >
            {enquiryTypesObject &&
              enquiryTypesObject.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
          </Select>
        </BoldLabelFormItem>
      </Col>
      {showCard && (
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            rules={[{ required: true, message: t('common.error.requiredField') }]}
            required
            label={
              <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                {t('life.enquiry.timeLabel')}
              </span>
            }
            name="contactTime"
          >
            <Select
              placeholder={t('life.enquiry.timeSlot')}
              popupClassName="slectop"
              style={{
                fontSize: '20px',
                fontFamily: 'Roboto400',
                fontWeight: 'normal',
                marginBottom: '10px',
                padding: '4px 0',
              }}
            >
              {timeTypesObject &&
                timeTypesObject.map((item) => (
                  <Select.Option key={item.label} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
            </Select>
          </BoldLabelFormItem>
        </Col>
      )}
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          rules={[{ required: true, message: t('life.enquiry.error.enquiryerror') }]}
          required
          label={
            <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.enquiry.enquiryMessageLabel')}
            </span>
          }
          name="feedback"
        >
          <TextArea
            showCount
            maxLength={500}
            placeholder={t(`life.enquiry.enquiryMessagePlaceholder`)}
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              fontWeight: 'normal',
              height: '220px',
              marginBottom: '10px',
            }}
          />
        </BoldLabelFormItem>
      </Col>
    </Row>
  );
};
